import React, { useState } from 'react'

import { FilterSection, GroupDrawerText } from '../../style'
import { FilterDropDown } from './style'
import TreeFilter from '../../../../../../../../../components/TreeSelectFilter'
import Checkbox from '../../../../../../../../../components/Form/Checkbox'

export const GroupFilters = ({
  groupInstFilterData,
  tierData,
  groupInstListSelectedFilter,
  onGroupFilterChange,
  // Add these props for dropdown search/filter
  groupStateOptions = [],
  groupCityOptions = [],
  onGroupStateSearch,
  onGroupCitySearch,
  onGroupStateDropdownClose,
  onGroupCityDropdownClose,
}) => {
  console.log(groupStateOptions,'groupStateOptions')
  console.log(groupCityOptions,'groupCityOptions')
  // Use API-driven data for states and cities
  // Tier search local
  const [tierOptions, setTierOptions] = useState(tierData)
  const handleTierSearch = searchText => {
    if (!searchText) setTierOptions(tierData)
    else
      setTierOptions(
        tierData.filter(t =>
          t.name.toLowerCase().includes(searchText.toLowerCase())
        )
      )
  }
  const handleTierDropdownClose = () => setTierOptions(tierData)

  return (
    <FilterSection>
      <Checkbox
        label="Show only PIL Recc."
        checked={!!groupInstListSelectedFilter?.pilRecommended}
        onChange={e =>
          onGroupFilterChange(e?.target?.checked, 'pilRecommended')
        }
        style={{ color: '#000000', fontWeight: 500 }}
      />

      {/* State Filter */}
      <TreeFilter
        treeData={groupStateOptions.map(opt => ({
          id: opt.state,
          key: opt.state+opt.stateId,
          name: opt.state,
          value: opt.state,
        }))}
        treeLoadedKeys={groupStateOptions.map(opt => opt.state+opt.stateId)}
        placeholder="Select filter"
        label={'State'}
        span={5}
        value={groupInstListSelectedFilter.selectedStates}
        onChange={onGroupFilterChange}
        valueKey="selectedStates"
        onSearch={onGroupStateSearch}
        onDropdownClose={onGroupStateDropdownClose}
      />

      {/* City Filter */}
      <TreeFilter
        treeData={groupCityOptions.map(opt => ({
          id: opt.city,
          key: opt.city+opt.cityId,
          name: opt.city,
          value: opt.city,      }))}
        treeLoadedKeys={groupCityOptions.map(opt => opt.city+opt.cityId)}
        label="City"
        placeholder="Select filters"
        span={5}
        value={groupInstListSelectedFilter.selectedCities}
        onChange={onGroupFilterChange}
        valueKey="selectedCities"
        onSearch={onGroupCitySearch}
        onDropdownClose={onGroupCityDropdownClose}
      />

      <TreeFilter
        treeData={tierOptions}
        placeholder="Select filter"
        label={'Tier Levels'}
        span={5}
        value={groupInstListSelectedFilter.selectedTiers}
        onChange={onGroupFilterChange}
        valueKey="selectedTiers"
        onSearch={handleTierSearch}
        onDropdownClose={handleTierDropdownClose}
      />
    </FilterSection>
  )
}
